<script setup lang="ts">
import { formatCurrency } from '../../../utilities/helpers'
import { useWalletState, WalletState } from '../../../utilities/account/useWallet'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import BaseButtonSecondary from '../../base/BaseButtonSecondary.vue'
import { computed, ref } from 'vue'
import WalletDepositModal from './WalletDepositModal.vue'
import WalletWithdrawalModal from './WalletWithdrawalModal.vue'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { checkWalletFeatureHidden, HideableWalletFeature } from '../../../utilities/useWalletSettings'
import { getCurrency } from '../../../utilities/usePlatformSettings'
import { onMounted } from 'vue'

const walletState = useWalletState() as WalletState

const accountState = usePersonalAccountDataState()

const showWalletDepositModal = ref(false)
const showWalletWithdrawalModal = ref(false)

const voucherTotalBalance = computed(() => {
    if (accountState.naturalProfile.vouchers?.length < 1) {
        return 0
    }

    return accountState.naturalProfile.vouchers.reduce((total, voucher) => {
        console.log(voucher.gift_card_balance)
        return total + voucher.gift_card_balance
    }, 0)
})

onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const withdrawal = urlParams.get('withdrawal')
    if (withdrawal && withdrawal === 'true') {
        showWalletWithdrawalModal.value = true
    }
})
</script>

<template>
    <WalletDepositModal v-if="walletState.wallet" v-model="showWalletDepositModal" />
    <WalletWithdrawalModal v-if="walletState.wallet" v-model="showWalletWithdrawalModal" />
    <div class="bg-white shadow sm:rounded-lg">
        <div
            class="mx-auto max-w-3xl px-4 py-6 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
            <div class="flex items-center space-x-5">
                <div v-if="walletState.wallet">
                    <p class="mt-1 max-w-2xl text-sm text-gray-500">{{ $t('wallet.retrievable_balance') }}</p>
                    <h2 id="applicant-information-title" class="text-xl font-medium leading-6 text-gray-900">
                        {{ formatCurrency(walletState.wallet.retrievable_balance, walletState.wallet.currency) }}
                    </h2>
                </div>
                <div v-if="isNaturalProfile() && accountState.naturalProfile.vouchers.length">
                    <p class="mt-1 max-w-2xl text-sm text-gray-500">{{ $t('wallet.voucher_balance') }}</p>
                    <h2 id="applicant-information-title" class="text-xl font-medium leading-6 text-gray-900">
                        {{ formatCurrency(voucherTotalBalance, getCurrency()) }}
                    </h2>
                </div>
            </div>
            <div
                v-if="walletState.wallet"
                class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
                <BaseButtonMuted
                    v-if="!checkWalletFeatureHidden(HideableWalletFeature.Withdrawal)"
                    @click="showWalletWithdrawalModal = true">
                    {{ $t('wallet.withdrawal_button') }}
                </BaseButtonMuted>
                <BaseButtonSecondary
                    v-if="!checkWalletFeatureHidden(HideableWalletFeature.Deposit)"
                    @click="showWalletDepositModal = true">
                    {{ $t('wallet.deposit_button') }}
                </BaseButtonSecondary>
            </div>
        </div>
    </div>
</template>
